// This store is used only by frontend to keep track of slots between
// components instead of sending full objects all around

import { cloneDeep } from "lodash-es";

export const slots = {
  namespaced: true,

  state: {
    slots: [],
  },

  actions: {
    addSlot({ commit }, { slotId, index, key, slotDescription }) {
      commit("ADD_SLOT", { slotId, index, key, slotDescription });
    },

    resetSlots({ commit }) {
      commit("RESET_SLOTS");
    },
  },

  mutations: {
    ADD_SLOT(state, { slotId, index, key, slotDescription }) {
      for (var slot of state.slots) {
        if (slotId === slot.slotId) return;

        if (
          slot.key == key &&
          slot.slotDescription == slotDescription &&
          slot.index == index
        )
          return;
      }

      state.slots.push({
        slotId: slotId === undefined ? crypto.randomUUID() : slotId,
        index: index,
        slot: "Node Slot " + index,
        key: key,
        slotDescription: slotDescription,
        priority: state.slots?.length + 1 ?? 0,
      });
    },

    ADD_KEY_TO_SLOT(state, index, key) {
      var slotIdx = state.slots.findIndex((d) => d.index == index);
      if (slotIdx == -1) return;

      state.slots[slotIdx].key = key;
    },

    RESET_SLOTS(state) {
      state.slots = [];
    },
  },

  getters: {
    getSlot: (state) => (index, key, slotDescription) => {
      var slot = state.slots.findIndex(
        (d) =>
          d.index == index &&
          d.key == key &&
          d.slotDescription == slotDescription
      );
      if (slot === -1) return null;

      return cloneDeep(state.slots[slot]);
    },

    getSlotNameById: (state) => (id) => {
      var slot = state.slots.findIndex((d) => d.slotId === id);
      if (slot === -1) return "";

      return (
        "Node Slot " + state.slots[slot].index + " - " + state.slots[slot].key
      );
    },

    getSlotName: (state) => (index, key, slotDescription) => {
      var slot = state.slots.findIndex(
        (d) =>
          d.index === index &&
          d.key === key &&
          d.slotDescription === slotDescription
      );
      if (slot === -1) return "";

      return `Node Slot ${state.slots[slot].index} - ${
        state.slots[slot].key != null
          ? state.slots[slot].key
          : state.slots[slot].slotDescription
      }`;
    },

    getSlotNameByIdentifierName: (state) => (index, slotDescription) => {
      var slot = state.slots.findIndex(
        (d) => d.index === index && d.slotDescription === slotDescription
      );
      if (slot === -1) return "";

      return (
        "Node Slot " +
        state.slots[slot].index +
        " - " +
        state.slots[slot].slotDescription
      );
    },
  },
};
